<template>
  <div>
    <el-card :body-style="{ padding: '0px' }">
      <img :src="imageUrl" class="YQ-invite-img">
      <div>
        <div class="bottom clearfix">
          <el-link :underline="false" class="YQ-invite-tip" type="primary">{{inviteTip}}</el-link>
          <div class="YQ-invite-button">
            <el-button type="text" @click="refuse_invite">关闭</el-button>
            <el-button type="text" @click="accept_invite">接受</el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "inviteChat",
  data() {
    return {
      imageUrl: '',
      inviteTip:'',
    }
  },
  mounted() {
    this.imageUrl = this.$route.query.imageUrl
    this.inviteTip = this.$route.query.inviteTip
    this.inviteTitle = this.$route.query.inviteTitle
  },
  methods:{
    //开启聊天窗口
    refuse_invite()
    {
      let data = {
        code : '204',
        msg : 'success'
      };
      window.parent.postMessage(data, '*');
    },
    accept_invite()
    {
      let data = {
        code : '203',
        msg : 'success'
      };
      window.parent.postMessage(data, '*');
    }

  },
}
</script>

<style scoped>
.YQ-invite-img{
  width: 360px;
  height: 160px;
  display: block;
}
.YQ-invite-tip{
  float: left;
  margin: 10px;
}
.YQ-invite-button{
  float: right;
  margin-right: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/inviteChat.vue